import React from 'react';

export interface EmailLinkProp {
  title: string;
  subject: string;
  label: string;
  email: string;
  className?: string;
}

export const EmailLink = ({ className, title, email, label, subject }: EmailLinkProp) => <>
  <a
    className={className}
    href={`mailto:${email}?subject=${subject}`}
    title={title}
    target="_blank" >
    <h2 className="help" style={{ marginTop: "2rem" }}>{label}</h2>
  </a>
</>

export default EmailLink